<template>
  <PinBtn
    v-if="!hide_pin_controls"
    :item="item"
    :myKey="myKey"></PinBtn>
  <PinAutoRefreshBtn
    v-if="!currentTemplate && !hide_activate_controls"
    :item="item"
    :myKey="myKey" />
  <v-card
    :style="`opacity: ${opaqueMode ? 1 : 0.5}`"
    flat
    class="mb-2 px-2"
    style="
      width: 100%;
      background: var(--v-field-color);
      display: flex;
      flex-direction: column;
    ">
    <v-card-subtitle style="margin-top: 7px">
      {{ item.label }}
    </v-card-subtitle>

    <div
      v-if="!realtime_mode"
      style="display: flex; justify-content: center; padding-bottom: 12px">
      <v-color-picker
        :disabled="readOnlyMode"
        class="ma-2 colorPicker"
        dot-size="30"
        flat
        rgba
        hide-mode-switch
        v-model="item.value"></v-color-picker>
    </div>

    <v-card-text
      v-else
      class="pa-0 ma-2">
      <v-menu
        :close-on-content-click="false"
        location="center"
        content-class="color-picker-menu">
        <template v-slot:activator="{ props: menuProps }">
          <div
            v-bind="menuProps"
            class="color-preview"
            :style="{
              backgroundColor: item.value,
              cursor: readOnlyMode ? 'default' : 'pointer',
            }"
            :title="readOnlyMode ? 'Color' : 'Click to change color'"></div>
        </template>
        <v-color-picker
          :disabled="readOnlyMode"
          class="ma-2 colorPicker"
          dot-size="30"
          flat
          rgba
          hide-mode-switch
          v-model="item.value"></v-color-picker>
      </v-menu>
    </v-card-text>
  </v-card>
  <div style="display: flex">
    <v-icon
      v-if="currentTemplate?.src_scene_data?.[myKey]"
      variant="flat"
      class="ml-3 refresh-button"
      style="height: 56px !important"
      @click="handleUserIntent(myKey, originLevel)"
      :style="unLockedMode ? 'opacity: 0.3' : 'opacity: 0.7'"
      :title="
        unLockedMode
          ? 'Value inherits from Template or Source'
          : 'Value locked. (Will not inherit from Template or Source)'
      "
      :icon="
        unLockedMode ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline'
      "></v-icon>
  </div>
</template>

<script setup>
import { ref, watch, computed, defineProps, defineEmits } from 'vue';
import { deluge } from '@/stores/deluge.js';
import { isOpaque } from './utils.js';
import PinBtn from './PinBtn.vue';
import PinAutoRefreshBtn from './PinAutoRefreshBtn.vue';
import PinSendNowBtn from './PinSendNowBtn.vue';
import { inheritanceHandler } from '../../../utils/inheritanceHandler';

const props = defineProps([
  'currentTemplate',
  'resetFunc',
  'originLevel',
  'myKey',
  'item',
  'hideicons',
  'hide_pin_controls',
  'hide_activate_controls',
  'readOnlyMode',
  'realtime_mode',
]);

const emit = defineEmits(['valueChanged']);

const opaqueMode = computed(() => {
  return isOpaque(deluge, props);
});

watch(
  () => props.item.value,
  () => {
    emit('valueChanged', [props.myKey, props.item.value]);
  }
);

const unLockedMode = ref(props.item.keyInherited);

function handleUserIntent(myKey, originLevel) {
  if (props.readOnlyMode) return;
  unLockedMode.value = !unLockedMode.value;
  props.item.userIntent = unLockedMode.value === true ? 'remove' : 'keep';
  if (unLockedMode.value === true) {
    props.resetFunc(myKey, originLevel);
  }
}

watch(
  () => props.item.value,
  () => {
    inheritanceHandler(props.item);
  },
  { immediate: true }
);
</script>

<style scoped>
.color-preview {
  width: 100%;
  height: 48px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}

.color-preview:hover {
  transform: scale(1.02);
}
</style>
